"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tokens = require("../../styles/tokens");
//import scrollbarSize from 'dom-helpers/scrollbarSize';

var ReactBigCalendarStyles = function ReactBigCalendarStyles(theme) {
  return {
    '@global': {
      '.rbc-container': {
        borderRadius: _tokens.borderRadiusMedium,
        boxShadow: "\n                0px 0.188rem 0.313rem -0.063rem rgba(0, 0, 0, 0.2),\n                0px 0.313rem " + _tokens.spacing30 + " 0px rgba(0, 0, 0, 0.14),\n                0px 0.063rem 0.875rem 0.063rem rgba(0, 0, 0, 0.12)\n            "
      },
      '.rbc-btn': {
        color: 'inherit',
        font: 'inherit',
        margin: '0'
      },
      'button.rbc-btn': {
        overflow: 'visible',
        textTransform: 'none',
        webkitAppearance: 'button',
        cursor: 'pointer'
      },
      'button[disabled].rbc-btn': {
        backgroundColor: theme.palette.grey[400],
        cursor: 'not-allowed'
      },
      'button.rbc-input::-moz-focus-inner': {
        border: '0',
        padding: '0'
      },
      '.rbc-calendar': {
        webkitBoxSizing: 'border-box',
        boxSizing: 'border-box',
        height: '100%',
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        webkitBoxAlign: 'stretch',
        msFlexAlign: 'stretch',
        alignItems: 'stretch',
        fontFamily: _tokens.fontFamilyDefault
      },
      '.rbc-calendar *, .rbc-calendar *:before, .rbc-calendar *:after': {
        webkitBoxSizing: 'inherit',
        boxSizing: 'inherit'
      },
      '.rbc-abs-full, .rbc-row-bg': {
        overflow: 'hidden',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0'
      },
      '.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label': {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      '.rbc-rtl': {
        direction: 'rtl',
        flip: false
      },
      '.rbc-off-range': {
        color: '#999999'
      },
      '.rbc-off-range-bg': {
        background: '#e6e6e6'
      },
      '.rbc-header': {
        overflow: 'hidden',
        webkitBoxFlex: '1',
        msFlex: '1 0 0%',
        flex: '1 0 0%',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        padding: "0 " + _tokens.spacing20,
        textAlign: 'center',
        verticalAlign: 'middle',
        color: theme.palette.grey[500],
        minHeight: '0',
        borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-header + .rbc-header': {
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-rtl .rbc-header + .rbc-header': {
        borderLeftWidth: '0',
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        flip: false
      },
      '.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited': {
        color: theme.palette.grey[500],
        textDecoration: 'none'
      },
      '.rbc-button-link': {
        fontFamily: 'inherit',
        fontWeight: 'bold',
        fontSize: _tokens.fontSizeSmall,
        color: 'inherit',
        background: 'none',
        margin: '0',
        padding: '0',
        border: 'none',
        cursor: 'pointer',
        webkitUserSelect: 'text',
        mozUserSelect: 'text',
        msUserSelect: 'text',
        userSelect: 'text'
      },
      '.rbc-row-content': {
        position: 'relative',
        mozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
        webkitUserSelect: 'none',
        zIndex: 4
      },
      '.rbc-row-content-scrollable': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        height: '100%'
      },
      '.rbc-row-content-scrollable .rbc-row-content-scroll-container': {
        height: '100%',
        overflowY: 'scroll',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
      },
      '.rbc-row-content-scrollable .rbc-row-content-scroll-container::-webkit-scrollbar': {
        display: 'none'
      },
      '.rbc-today': {
        // backgroundColor: theme.palette.ctaColor.tint
      },
      /* START top-toolbar */
      '.rbc-toolbar': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        msFlexWrap: 'wrap',
        flexWrap: 'wrap',
        webkitBoxPack: 'center',
        msFlexPack: 'center',
        justifyContent: 'center',
        webkitBoxAlign: 'center',
        msFlexAlign: 'center',
        alignItems: 'center',
        marginBottom: '10px',
        fontSize: _tokens.fontSizeLarge,
        marginRight: _tokens.spacing30
      },
      '.rbc-toolbar .rbc-toolbar-label': {
        webkitBoxFlex: '1',
        msFlexPositive: '1',
        flexGrow: '1',
        padding: '0 10px',
        textAlign: 'center'
      },
      '.rbc-toolbar button': {
        color: '#373a3c',
        display: 'inline-block',
        margin: '0',
        textAlign: 'center',
        verticalAlign: 'middle',
        background: 'none',
        backgroundImage: 'none',
        border: '1px solid #ccc',
        padding: '0.375rem 1rem',
        borderRadius: '4px',
        lineHeight: 'normal',
        whiteSpace: 'nowrap'
      },
      '.rbc-toolbar button:active, .rbc-toolbar button.rbc-active': {
        backgroundImage: 'none',
        webkitBoxShadow: 'inset 0 3px 5px rgba(0, 0, 0, 0.125)',
        boxShadow: 'inset 0 3px 5px rgba(0, 0, 0, 0.125)',
        backgroundColor: '#e6e6e6',
        borderColor: '#adadad'
      },
      '.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus': {
        color: '#373a3c',
        backgroundColor: '#d4d4d4',
        borderColor: '#8c8c8c'
      },
      '.rbc-toolbar button:focus': {
        color: '#373a3c',
        backgroundColor: '#e6e6e6',
        borderColor: '#adadad'
      },
      '.rbc-toolbar button:hover': {
        color: '#373a3c',
        backgroundColor: '#e6e6e6',
        borderColor: '#adadad'
      },
      /* END top-toolbar */
      /* START btn-group */
      '.rbc-btn-group': {
        display: 'inline-block',
        whiteSpace: 'nowrap'
      },
      '.rbc-btn-group > button:first-child:not(:last-child)': {
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0'
      },
      '.rbc-btn-group > button:last-child:not(:first-child)': {
        borderTopLeftRadius: '0',
        borderBottomLeftRadius: '0'
      },
      '.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child)': {
        borderRadius: '4px',
        borderTopLeftRadius: '0',
        borderBottomLeftRadius: '0',
        flip: false
      },
      '.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child)': {
        borderRadius: '4px',
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
        flip: false
      },
      '.rbc-btn-group > button:not(:first-child):not(:last-child)': {
        borderRadius: '0'
      },
      '.rbc-btn-group button + button': {
        marginLeft: '-1px'
      },
      '.rbc-rtl .rbc-btn-group button + button': {
        marginLeft: '0',
        marginRight: '-1px',
        flip: false
      },
      '.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button': {
        marginLeft: '10px'
      },
      // START: Event
      '.rbc-event, .rbc-day-slot .rbc-background-event': {
        border: 'none',
        boxShadow: "0 0.125rem " + _tokens.sizingXxSmall + " 0.063rem rgba(0, 0, 0, 0.3)",
        margin: 0,
        padding: "0.125rem " + _tokens.spacing20,
        backgroundColor: theme.palette.common.white,
        borderLeft: _tokens.borderRadiusSmall + " solid " + theme.palette.tertiary.fountain[600],
        borderRadius: _tokens.borderRadiusXSmall,
        color: '#151618',
        cursor: 'pointer',
        width: '100%',
        textAlign: 'left',
        fontFamily: _tokens.fontFamilyDefault,
        fontSize: _tokens.fontSizeSmall
      },
      '.rbc-slot-selecting .rbc-event, .rbc-slot-selecting .rbc-day-slot .rbc-background-event, .rbc-day-slot .rbc-slot-selecting .rbc-background-event': {
        cursor: 'inherit',
        pointerEvents: 'none'
      },
      '.rbc-event.rbc-selected, .rbc-day-slot .rbc-selected.rbc-background-event': {
        // outline: `${sizingXxSmall} auto ${theme.palette.tertiary.fountain[600]}`
        backgroundColor: theme.palette.common.white
      },
      '.rbc-event:focus, .rbc-day-slot .rbc-background-event:focus': {
        outline: _tokens.sizingXxSmall + " auto " + theme.palette.tertiary.fountain[600]
      },
      '.rbc-event-label': {
        fontSize: _tokens.fontSizeSmall
      },
      '.rbc-event-overlaps': {
        webkitBoxShadow: '-1px 1px 5px 0px rgba(51, 51, 51, 0.5)',
        boxShadow: '-1px 1px 5px 0px rgba(51, 51, 51, 0.5)'
      },
      '.rbc-event-continues-prior': {
        borderTopLeftRadius: '0',
        borderBottomLeftRadius: '0'
      },
      '.rbc-event-continues-after': {
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0'
      },
      '.rbc-event-continues-earlier': {
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0'
      },
      '.rbc-event-continues-later': {
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0'
      },
      // END: Event
      '.rbc-row': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'horizontal',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'row',
        flexDirection: 'row'
      },
      '.rbc-row-segment': {
        padding: '0 0.063rem 0.063rem 0.063rem'
      },
      '.rbc-selected-cell': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      },
      '.rbc-show-more': {
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        zIndex: '4',
        fontWeight: 'bold',
        fontSize: '85%',
        height: 'auto',
        lineHeight: 'normal',
        color: '#3174ad'
      },
      '.rbc-show-more:hover, .rbc-show-more:focus': {
        color: '#265985'
      },
      '.rbc-month-view': {
        position: 'relative',
        border: '1px solid #ddd',
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        webkitBoxFlex: '1',
        msFlex: '1 0 0px',
        flex: '1 0 0',
        width: '100%',
        mozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
        webkitUserSelect: 'none',
        height: '100%'
      },
      '.rbc-month-header': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'horizontal',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'row',
        flexDirection: 'row'
      },
      '.rbc-month-row': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        position: 'relative',
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        webkitBoxFlex: '1',
        msFlex: '1 0 0px',
        flex: '1 0 0',
        msFlexPreferredSize: '0px',
        flexBasis: '0px',
        overflow: 'hidden',
        height: '100%'
      },
      '.rbc-month-row + .rbc-month-row': {
        borderTop: '1px solid #ddd'
      },
      '.rbc-date-cell': {
        webkitBoxFlex: '1',
        msFlex: '1 1 0px',
        flex: '1 1 0',
        minWidth: '0',
        paddingRight: '5px',
        textAlign: 'right'
      },
      '.rbc-date-cell.rbc-now': {
        fontWeight: 'bold'
      },
      '.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited': {
        color: 'inherit',
        textDecoration: 'none'
      },
      '.rbc-row-bg': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'horizontal',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'row',
        flexDirection: 'row',
        webkitBoxFlex: '1',
        msFlex: '1 0 0px',
        flex: '1 0 0',
        overflow: 'hidden'
      },
      '.rbc-day-bg': {
        webkitBoxFlex: '1',
        msFlex: '1 0 0%',
        flex: '1 0 0%'
      },
      '.rbc-day-bg + .rbc-day-bg': {
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-rtl .rbc-day-bg + .rbc-day-bg': {
        borderLeftWidth: '0',
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        flip: false
      },
      '.rbc-overlay': {
        position: 'absolute',
        zIndex: '5',
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        backgroundColor: '#fff',
        webkitBoxShadow: '0 5px 15px rgba(0, 0, 0, 0.25)',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.25)',
        padding: '10px'
      },
      '.rbc-overlay > * + *': {
        marginTop: '1px'
      },
      '.rbc-overlay-header': {
        borderBottom: '1px solid #e5e5e5',
        margin: '-10px -10px 5px -10px',
        padding: '2px 10px'
      },
      '.rbc-agenda-view': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        webkitBoxFlex: '1',
        msFlex: '1 0 0px',
        flex: '1 0 0',
        overflow: 'auto'
      },
      '.rbc-agenda-view table.rbc-agenda-table': {
        width: '100%',
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        borderSpacing: '0',
        borderCollapse: 'collapse'
      },
      '.rbc-agenda-view table.rbc-agenda-table tbody > tr > td': {
        padding: '.3125rem .625rem',
        verticalAlign: 'top'
      },
      '.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell': {
        paddingLeft: '.9375rem',
        paddingRight: '.9375rem',
        textTransform: 'lowercase'
      },
      '.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td': {
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td': {
        borderLeftWidth: '0',
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        flip: false
      },
      '.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr': {
        borderTop: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-agenda-view table.rbc-agenda-table thead > tr > th': {
        padding: '3px 5px',
        textAlign: 'left',
        borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th': {
        textAlign: 'right',
        flip: false
      },
      '.rbc-agenda-time-cell': {
        textTransform: 'lowercase'
      },
      '.rbc-agenda-time-cell .rbc-continues-after:after': {
        content: '" »"'
      },
      '.rbc-agenda-time-cell .rbc-continues-prior:before': {
        content: '"« "'
      },
      '.rbc-agenda-date-cell, .rbc-agenda-time-cell': {
        whiteSpace: 'nowrap'
      },
      '.rbc-agenda-event-cell': {
        width: '100%'
      },
      '.rbc-time-column': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        minHeight: '100%'
      },
      '.rbc-time-column .rbc-timeslot-group': {
        webkitBoxFlex: '1',
        msFlex: '1',
        flex: '1'
      },
      /* NOTE: Add this back in to get the even/odd row background-color styling. */
      '.rbc-time-column .rbc-timeslot-group:nth-child(odd)': {
        backgroundColor: theme.palette.grey[200]
      },
      '.rbc-time-column .rbc-timeslot-group:nth-child(odd).rbc-today': {
        backgroundColor: theme.palette.grey[200]
      },
      '.rbc-timeslot-group': {
        minHeight: _tokens.sizingLarge,
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexFlow: 'column nowrap',
        flexFlow: 'column nowrap'
      },
      '.rbc-time-gutter, .rbc-header-gutter': {
        webkitBoxFlex: '0',
        msFlex: 'none',
        flex: 'none'
      },
      '.rbc-label': {
        padding: '0 0.313rem',
        fontSize: _tokens.fontSizeSmall,
        color: theme.palette.grey[500]
      },
      '.rbc-day-slot': {
        position: 'relative'
      },
      '.rbc-day-slot .rbc-events-container': {
        bottom: '0',
        left: '0',
        position: 'absolute',
        right: '0',
        marginRight: '.625rem',
        top: '0'
      },
      '.rbc-day-slot .rbc-events-container.rbc-rtl': {
        left: '.625rem',
        right: '0',
        flip: false
      },
      '.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        maxHeight: '100%',
        minHeight: '20px',
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexFlow: 'column wrap',
        flexFlow: 'column wrap',
        webkitBoxAlign: 'start',
        msFlexAlign: 'start',
        alignItems: 'flex-start',
        overflow: 'hidden',
        position: 'absolute'
      },
      '.rbc-day-slot .rbc-background-event': {
        opacity: '0.75'
      },
      '.rbc-day-slot .rbc-event-label': {
        webkitBoxFlex: '0',
        msFlex: 'none',
        flex: 'none',
        paddingRight: '.3125rem',
        width: 'auto'
      },
      '.rbc-day-slot .rbc-event-content': {
        width: '100%',
        webkitBoxFlex: '1',
        msFlex: '1 1 0px',
        flex: '1 1 0',
        wordWrap: 'break-word',
        lineHeight: '1',
        height: '100%',
        minHeight: '1em',
        paddingTop: 2.6
      },
      '.rbc-day-slot .rbc-time-slot': {
        // borderTop: `${borderWidthThin} solid ${theme.palette.grey[300]}`
      },
      '.rbc-time-view-resources .rbc-time-gutter, .rbc-time-view-resources .rbc-time-header-gutter': {
        position: 'sticky',
        left: '0',
        backgroundColor: 'white',
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        zIndex: '10',
        marginRight: '-1px'
      },
      '.rbc-time-view-resources .rbc-time-header': {
        overflow: 'hidden'
      },
      '.rbc-time-view-resources .rbc-time-header-content': {
        minWidth: 'auto',
        webkitBoxFlex: '1',
        msFlex: '1 0 0px',
        flex: '1 0 0',
        msFlexPreferredSize: '0px',
        flexBasis: '0px'
      },
      '.rbc-time-view-resources .rbc-time-header-cell-single-day': {
        display: 'none'
      },
      '.rbc-time-view-resources .rbc-day-slot': {
        minWidth: '140px'
      },
      '.rbc-time-view-resources .rbc-header, .rbc-time-view-resources .rbc-day-bg': {
        width: '140px',
        webkitBoxFlex: '1',
        msFlex: '1 1 0px',
        flex: '1 1 0',
        msFlexPreferredSize: '0 px',
        flexBasis: '0 px'
      },
      '.rbc-time-header-content + .rbc-time-header-content': {
        marginLeft: '-1px'
      },
      '.rbc-time-slot': {
        webkitBoxFlex: '1',
        msFlex: '1 0 0px',
        flex: '1 0 0'
      },
      '.rbc-time-slot.rbc-now': {
        fontWeight: 'bold'
      },
      '.rbc-day-header': {
        textAlign: 'center'
      },
      '.rbc-slot-selection': {
        zIndex: '10',
        position: 'absolute',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: 'white',
        fontSize: '75%',
        width: '100%',
        padding: '.1875rem'
      },
      '.rbc-slot-selecting': {
        cursor: 'move'
      },
      '.rbc-time-view': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        webkitBoxFlex: '1',
        msFlex: '1',
        flex: '1',
        width: '100%',
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        minHeight: '0'
      },
      '.rbc-time-view .rbc-time-gutter': {
        whiteSpace: 'nowrap',
        textAlign: 'right'
      },
      '.rbc-time-view .rbc-allday-cell': {
        webkitBoxSizing: 'content-box',
        boxSizing: 'content-box',
        width: '100%',
        height: '100%',
        position: 'relative'
      },
      '.rbc-time-view .rbc-allday-cell + .rbc-allday-cell': {
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-time-view .rbc-allday-events': {
        position: 'relative',
        zIndex: '4'
      },
      'rbc-event, .rbc-event-allday': {
        marginLeft: 0
      },
      '.rbc-time-view .rbc-row': {
        webkitBoxSizing: 'border-box',
        boxSizing: 'border-box',
        minHeight: '1.25rem'
      },
      '.rbc-time-header': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxFlex: '0',
        msFlex: '0 0 auto',
        flex: '0 0 auto',
        webkitBoxOrient: 'horizontal',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'row',
        flexDirection: 'row'
      },
      '.rbc-time-header.rbc-overflowing': {
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-rtl .rbc-time-header.rbc-overflowing': {
        borderRightWidth: '0',
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        flip: false
      },
      '.rbc-time-header > .rbc-row:first-child': {
        borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-time-header > .rbc-row.rbc-row-resource': {
        borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-time-header-cell-single-day': {
        display: 'none'
      },
      '.rbc-time-header-content': {
        webkitBoxFlex: '1',
        msFlex: '1',
        flex: '1',
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        minWidth: '0',
        webkitBoxOrient: 'vertical',
        webkitBoxDirection: 'normal',
        msFlexDirection: 'column',
        flexDirection: 'column',
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-rtl .rbc-time-header-content': {
        borderLeftWidth: '0',
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        flip: false
      },
      '.rbc-time-header-content > .rbc-row.rbc-row-resource': {
        borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        msFlexNegative: '0',
        flexShrink: '0'
      },
      '.rbc-time-content': {
        display: 'flex',
        fallbacks: [{
          display: '-ms-flexbox'
        }, {
          display: '-webkit-box'
        }],
        webkitBoxFlex: '1',
        msFlex: '1 0 0%',
        flex: '1 0 0%',
        webkitBoxAlign: 'start',
        msFlexAlign: 'start',
        alignItems: 'flex-start',
        width: '100%',
        borderTop: _tokens.borderWidthThick + " solid " + theme.palette.grey[300],
        overflowY: 'auto',
        position: 'relative',
        '&:focus': {
          outline: 'none',
          boxShadow: _tokens.boxShadowFocus
        }
      },
      '.rbc-time-content > .rbc-time-gutter': {
        webkitBoxFlex: '0',
        msFlex: 'none',
        flex: 'none'
      },
      '.rbc-time-content > * + * > *': {
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '.rbc-rtl .rbc-time-content > * + * > *': {
        borderLeftWidth: '0',
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        flip: false
      },
      '.rbc-time-content > .rbc-day-slot': {
        width: '100%',
        mozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
        webkitUserSelect: 'none'
      },
      '.rbc-current-time-indicator': {
        position: 'absolute',
        left: '0',
        right: '0',
        height: '.125rem',
        backgroundColor: '#D4282840',
        pointerEvents: 'none'
      },
      '.rbc-current-time-indicator:before': {
        content: '""',
        display: 'block',
        width: '.75rem',
        height: '.75rem',
        transform: 'translate(-0.28125rem, -.313rem)',
        borderRadius: _tokens.borderRadiusCircle,
        border: _tokens.borderWidthThin + " solid white",
        backgroundColor: _tokens.colorTextAlertError
      }
    }
  };
};
var _default = exports.default = ReactBigCalendarStyles;